import { Button, cn } from "@tellescope/design-system";
import { FilePlus2 } from "lucide-react";
import { BlockProps } from "../../../types";
import { useFilesBlock } from "../../../hooks";
import { BlockHeader } from "../BlockHeader";
import { BlockContent } from "../BlockContent";
import { FilesRecordsList } from "./FilesRecordsList";
import { UploadFileForm } from "./UploadFileForm";
import { useTranslation } from "react-i18next";
import { BlockEmptyState } from "../BlockEmptyState";

export const FilesBlock = ({
  onMaximize,
  alwaysShowButtons = false,
  className,
  contentClassName,
  ...rest
}: BlockProps) => {
  const { t } = useTranslation("files");
  const {
    parsedInfo,
    enduser,
    showUploadForm,
    openUploadForm,
    closeUploadForm,
    isEditingTitle,
    setIsEditingTitle,
    newTitle,
    setNewTitle,
    editMode,
    setEditMode,
    updateInfo,
    duplicateBlock,
    deleteBlock,
    toggleExpanded,
    expanded,
    blockLayout,
    canEditTitle,
    canCreateBlock,
    canDeleteBlock,
  } = useFilesBlock({ ...rest, onMaximize, alwaysShowButtons, className });

  return (
    <div className={cn("group", className)}>
      <BlockHeader
        editMode={editMode}
        setEditMode={setEditMode}
        isEditingTitle={isEditingTitle}
        setIsEditingTitle={setIsEditingTitle}
        newTitle={newTitle}
        setNewTitle={setNewTitle}
        canEditTitle={canEditTitle}
        parsedInfo={parsedInfo}
        updateInfo={updateInfo}
        duplicateBlock={duplicateBlock}
        deleteBlock={deleteBlock}
        canCreateBlock={canCreateBlock}
        canDeleteBlock={canDeleteBlock}
        onMaximize={onMaximize}
        alwaysShowButtons={alwaysShowButtons}
        actions={
          editMode &&
          !showUploadForm && (
            <Button variant="outline" size="sm" onClick={openUploadForm}>
              <FilePlus2 />
              {t("Upload File")}
            </Button>
          )
        }
      />

      <BlockContent
        editMode={editMode}
        setEditMode={setEditMode}
        expanded={expanded}
        layout={blockLayout}
        onToggleExpanded={() => toggleExpanded()}
        className={cn("flex flex-col", contentClassName)}
      >
        {!enduser ? (
          <div className="flex flex-1 items-center justify-center">
            <BlockEmptyState>{t("Loading files...")}</BlockEmptyState>
          </div>
        ) : showUploadForm ? (
          <UploadFileForm contactId={enduser.id} onUpload={closeUploadForm} />
        ) : (
          <FilesRecordsList contact={enduser} />
        )}
      </BlockContent>
    </div>
  );
};
